import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PointHistoryPageRoutingModule } from './point-history-routing.module';

import { PointHistoryPage } from './point-history.page';
import { TranslateModule } from '@ngx-translate/core';
//import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';
import { InputSelectModalPointsPageModule } from 'src/app/component/input-select-modal-points/input-select-modal-points.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PointHistoryPageRoutingModule,
    TranslateModule,
    InputSelectModalPointsPageModule
  ],
  declarations: [PointHistoryPage],
  exports:[PointHistoryPage]
})
export class PointHistoryPageModule {}
